module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "70%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.DeliveryStatusName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentCode) + "   " + _vm._s(_vm.Form.AgentName) + "   " + _vm._s(_vm.Form.AgentAddress) + "   " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ListGoods != ''),
      expression: "Form.ListGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.ListGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.GiftGoods != ''),
      expression: "Form.GiftGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.GiftGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))])]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isList),
      expression: "this.isList"
    }],
    ref: "form2",
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "color": "black",
      "font-size": "18px",
      "font-weight": "bold"
    },
    attrs: {
      "label": "出库情况"
    }
  }), _vm._v(" "), _c('el-collapse', {
    staticStyle: {
      "width": "80%",
      "margin": "-45px 205px 20px"
    },
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.Form.OutList), function(item, index) {
    return _c('el-collapse-item', {
      attrs: {
        "title": '出库单号' + (index + 1),
        "name": index
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "出库单号"
      }
    }, [_c('span', [_vm._v(_vm._s(item.StockOutCode))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "收货状态"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ReceivingStatusName))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ListGoods != ''),
        expression: "item.ListGoods!=''"
      }],
      staticStyle: {
        "width": "700px"
      },
      attrs: {
        "label": "商品"
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "80%",
        "margin-left": "25px"
      },
      attrs: {
        "data": item.ListGoods,
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "ProName",
        "label": "名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ProNum",
        "label": "实发"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ReceiveNum",
        "label": "实收"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.GiftGoods != ''),
        expression: "item.GiftGoods!=''"
      }],
      staticStyle: {
        "width": "700px"
      },
      attrs: {
        "label": "赠品"
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "80%",
        "margin-left": "25px"
      },
      attrs: {
        "data": item.GiftGoods,
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "ProName",
        "label": "名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "SendNum",
        "label": "应发"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ProNum",
        "label": "实发"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ReceiveNum",
        "label": "实收"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "实际发货时间"
      }
    }, [(item.StockOutTime != '' && item.StockOutTime != undefined) ? _c('span', [_vm._v(_vm._s(item.StockOutTime))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "实际签收时间"
      }
    }, [(item.SignTime != '' && item.SignTime != undefined) ? _c('span', [_vm._v(_vm._s(item.SignTime))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "快递或物流名称"
      }
    }, [(item.LogisticsName != '' && item.LogisticsName != undefined) ? _c('span', [_vm._v(_vm._s(item.LogisticsName))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "快递或物流单号"
      }
    }, [(item.LogisticsCode != '' && item.LogisticsCode != undefined) ? _c('span', [_vm._v(_vm._s(item.LogisticsCode))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "出库单备注"
      }
    }, [(item.Remark != '' && item.Remark != undefined) ? _c('span', [_vm._v(_vm._s(item.Remark))]) : _c('span', [_vm._v("--")])])], 1)
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("我知道了")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-543480c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SendGoods/ViewSendGoodsForBus.vue
// module id = 1483
// module chunks = 1